import crypt from 'crypto';

export function sha256(str: string): string {
  return crypt.createHash('sha256').update(str).digest('hex');
}
